import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'

//import {md5} from 'pure-md5'
const md5 = require('blueimp-md5')

Vue.use(Vuex)

// const vueAuth = Vue.prototype.$auth

export default new Vuex.Store({
    state: {
        isAuthenticated: false,
        user: {},
        utility: {
            snackbarColor: "error",
            snackbar: false,
            snackbarText: "Test error message"
        }
    },
    // You can use it as a state getter function (probably the best solution)
    /* getters: {
         isAuthenticated() {
             return Vue.prototype.$auth.isAuthenticated()
         }
     },*/
    mutations: {
        isAuthenticated(state, payload) {
            state.isAuthenticated = payload.isAuthenticated
        },
        user(state, payload) {
            state.user = payload.user
        },
        "user.agenda": function(state, payload) {
            state.user.agenda = payload.user.agenda
        },
        utility(state, payload) {
            state.utility = payload.utility
        }
    },
    actions: {
        processError(context, payload, successMessage) {
            let errorMessage = ""
            if (payload.status !== 200) {
                // eslint-disable-next-line
                console.log(payload)

                if (payload.data.error) {
                    errorMessage = (payload.data.error.msg) ? payload.data.error.msg : ""
                    if (payload.data.error.cause) {
                        errorMessage = errorMessage + (payload.data.error.cause.msg) ? payload.data.error.cause.msg : ""
                    }
                }
                context.commit('utility', {
                    utility: {
                        snackbarColor: "error",
                        snackbar: true,
                        snackbarText: errorMessage
                    }
                })

                if (payload.status === 401) {
                    // eslint-disable-next-line
                    console.log("CurrentRoute", router.currentRoute)

                    context.commit('isAuthenticated', {
                        isAuthenticated: false
                    })
                    //router.push({path: '/user/login', query: {redirect: router.currentRoute.fullPath}})
                    //router.push(router.currentRoute.fullPath)
                    router.go(-1)
                    router.go(1)
                }
            }
            else {
                if (successMessage) {
                    context.commit('utility', {
                        utility: {
                            snackbarColor: "info",
                            snackbar: true,
                            snackbarText: successMessage
                        }
                    })
                }
            }
        },

        checkLogin(context, payload) {
            Vue.prototype.$auth.isAuthenticated()
            return Vue.prototype.$http.post('/profile/get', payload).then(function (response) {
                context.commit('isAuthenticated', {
                    isAuthenticated: Vue.prototype.$auth.isAuthenticated()
                })

                if(response.status===200){
                    if (response.data.user) {
                        context.commit('user', {
                            user: response.data.user
                        })
                    }
                }
                return response;
            });

        },
        // Perform VueAuthenticate login using Vuex actions
        login(context, payload) {
            if (Vue.prototype.$auth.isAuthenticated()) {
                Vue.prototype.$auth.logout()
            }

            return Vue.prototype.$auth.login({email:payload.user.email, password:md5(payload.user.password, 'n3i2c3k3')}, payload.requestOptions).then((response) => {
                context.commit('isAuthenticated', {
                    isAuthenticated: Vue.prototype.$auth.isAuthenticated()
                })
                if (response.status === 200) {
                    if (response.data.user) {
                        context.commit('user', {
                            user: response.data.user
                        })
                    }
                }
                return response
            })
        },
        loadProfile(context, payload) {
            var this_ = this;
            return Vue.prototype.$http.post('/profile/get', payload).then(function (response) {

                if(response.status!==200) this_.dispatch('processError', response)
                else {
                    if (response.data.user) {
                        context.commit('user', {
                            user: response.data.user
                        })
                    }
                }
                return response;
            });
        },
        updateProfile(context, payload) {
            var this_ = this;
            return Vue.prototype.$http.post('/profile/set', payload).then(function (response) {
                this_.dispatch('processError', response, 'Успешно сохранено')
                if(response.status === 200) {
                    if (response.data.user) {
                        context.commit('user', {
                            user: response.data.user
                        })
                    }
                }
                return response;
            });
        },
        changePassword(context, payload) {
            var this_ = this;
            return Vue.prototype.$http.post('/password/change', {password:md5(payload.password, 'n3i2c3k3'),newPassword:md5(payload.newPassword, 'n3i2c3k3')}).then(function (response) {
                // eslint-disable-next-line
                //console.log(response)
                this_.dispatch('processError', response, 'Успешно сохранено')
                if(response.status === 200) {

                    /*                    if (response.data.user) {
                                            context.commit('user', {
                                                user: response.data.user
                                            })
                                        }*/
                }
                return response;
            });
        },
        updateAgenda(context, payload) {
            var this_ = this;
            return Vue.prototype.$http.post('/agenda/set', payload).then(function (response) {

                this_.dispatch('processError', response, 'Успешно сохранено')
                if(response.status === 200) {
                    if (response.data.user) {
                        /*context.commit('user.agenda', {
                            user: {agenda: response.data.user.agenda}
                        })*/
                        context.commit('user', {
                            user: response.data.user
                        })
                    }
                }
                return response;
            });
        },
        register(context, payload) {
            payload.user.password = md5(payload.user.password, 'n3i2c3k3')
            return Vue.prototype.$auth.register(payload.user, payload.requestOptions).then((response) => {
                // eslint-disable-next-line
                console.log(Vue.prototype.$auth.isAuthenticated(),response)
                context.commit('isAuthenticated', {
                    isAuthenticated: Vue.prototype.$auth.isAuthenticated()
                })
                if (response.status === 200) {
                    if (response.data.user) {
                        context.commit('user', {
                            user: response.data.user
                        })
                    }
                }
                return response
            })
        },
        logout(context, payload) {
            return Vue.prototype.$auth.logout(payload.requestOptions).then(() => {
                context.commit('isAuthenticated', {
                    isAuthenticated: Vue.prototype.$auth.isAuthenticated()
                })
            })
        },
        addTestCode(context, payload) {
            var this_ = this;
            return Vue.prototype.$http.get('/testcode/register?key=' + payload.key, payload).then(function (response) {
                this_.dispatch('processError', response)
                if (response.status === 200) {
                    if (response.data.user) {
                        context.commit('user', {
                            user: response.data.user
                        })
                    }
                }
                return response;
            });
        },

        adminAddTestCode(context, payload) {
            return Vue.prototype.$http.post('/admin/testcodes/register', payload).then(function (response) {
                if (response.status === 200) {
                    // eslint-disable-next-line
                    console.log(response)

                }
                return response;
            });
        },
        gettestfiledata(context, payload) {
            return Vue.prototype.$http.post('/gettestfiledata', payload).then(function (response) {
                if (response.status === 200) {
                    // eslint-disable-next-line
                    console.log(response)

                }
                return response;
            });
        },
        regReport(context, payload) {
            return Vue.prototype.$http.post('/admin/reports/register', payload).then(function (response) {
                if (response.status === 200) {
                    // eslint-disable-next-line
                    console.log(response)
                }
                return response;
            });
        },
        adminTestList(context, payload) {
            return Vue.prototype.$http.post('/admin/testcodes', payload).then(function (response) {
                if (response.status === 200) {
                    // eslint-disable-next-line
                    //console.log(response)
                }
                return response;
            });
        },
        adminReportList(context, payload) {
            var this_ = this;
            return Vue.prototype.$http.post('/admin/reports', payload).then(function (response) {
                this_.dispatch('processError', response)
                if (response.status === 200) {
                    // eslint-disable-next-line
                    //console.log(response)
                }
                return response;
            });
        },
        adminRetailRegList(context, payload) {
            var this_ = this;
            return Vue.prototype.$http.post('/retail-reg-data/list', payload).then(function (response) {
                this_.dispatch('processError', response)
                if (response.status === 200) {
                    // eslint-disable-next-line
                    //console.log(response)
                }
                return response;
            });
        },
        adminRetailBulkImport(context, payload) {
            var this_ = this;
            return Vue.prototype.$http.post('/retail-reg-data/bulk', payload).then(function (response) {
                this_.dispatch('processError', response)
                if (response.status === 200) {
                    // eslint-disable-next-line
                    //console.log(response)
                }
                return response;
            });
        },
        adminRetailGet(context, payload) {
            var this_ = this;
            return Vue.prototype.$http.get('/retail-reg-data/get?reg_code='+ payload.code, payload).then(function (response) {
                this_.dispatch('processError', response)
                if (response.status === 200) {
                    // eslint-disable-next-line
                    //console.log(response)
                }
                return response;
            });
        },
        adminRetailDelete(context, payload) {
            var this_ = this;
            return Vue.prototype.$http.get('/retail-reg-data/delete?reg_code='+ payload.code, payload).then(function (response) {
                this_.dispatch('processError', response)
                if (response.status === 200) {
                    // eslint-disable-next-line
                    //console.log(response)
                }
                return response;
            });
        },
        adminRetailReg(context, payload) {
            var this_ = this;
            return Vue.prototype.$http.post('/retail-reg-data/reg', payload).then(function (response) {
                this_.dispatch('processError', response)
                if (response.status === 200) {
                    // eslint-disable-next-line
                    //console.log(response)
                }
                return response;
            });
        },
        adminRetailRegNew(context, payload) {
            var this_ = this;
            return Vue.prototype.$http.post('/retail-reg-data/reg-new', payload).then(function (response) {
                this_.dispatch('processError', response)
                if (response.status === 200) {
                    // eslint-disable-next-line
                    //console.log(response)
                }
                return response;
            });
        },
        adminReportGet(context, payload) {
            var this_ = this;
            return Vue.prototype.$http.post('/admin/reports/get', payload).then(function (response) {
                this_.dispatch('processError', response)
                // eslint-disable-next-line
                console.log(response)

                if (response.status === 200) {
                    // eslint-disable-next-line
                    //console.log(response)
                }
                return response;
            });
        },
        reportCombo(context, payload) {
            var this_ = this;
            return Vue.prototype.$http.get('/combo-report?testId='+payload.testId, payload).then(function (response) {
                this_.dispatch('processError', response)
                if (response.status === 200) {
                    // eslint-disable-next-line
                    //console.log(response)
                }
                return response;
            });
        },
        adminReportSet(context, payload) {
            var this_ = this;
            return Vue.prototype.$http.post('/admin/reports/set', payload).then(function (response) {
                this_.dispatch('processError', response, 'Успешно сохранено')
                if(response.status === 200) {
                    // eslint-disable-next-line
                    console.log(response)
                }
                return response;
            });
        }


    }
})
